import Vue from 'vue';
import Router from 'vue-router';
import LoginForm from './components/LoginForm.vue';
import SearchPage from './components/SearchPage.vue';
import TraineeDetails from './components/TraineeDetails.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    { 
      path: '/login', 
      name: 'LoginForm', 
      component: LoginForm,
      meta: { title: 'تسجيل الدخول - MBFit Training Web' }
    },
    { 
      path: '/', 
      redirect: () => {
        const token = localStorage.getItem('api_token');
        return token ? { name: 'SearchPage' } : { name: 'LoginForm' };
      }
    },
    { 
      path: '/search', 
      name: 'SearchPage', 
      component: SearchPage,
      meta: { requiresAuth: true, title: 'البحث - MBFit Training Web' }
    },
    { 
      path: '/trainee/:id', 
      name: 'TraineeDetails', 
      component: TraineeDetails, 
      props: true,
      meta: { requiresAuth: true, title: 'تفاصيل المتدرب - MBFit Training Web' }
    },
  ],
});

// Navigation guard for authentication and page titles
router.beforeEach((to, from, next) => {
  // Set page title
  document.title = to.meta.title || 'MBFit Training Web';
  
  const token = localStorage.getItem('api_token');
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({ name: 'LoginForm' });
    } else {
      next();
    }
  } else {
    if (token && to.name === 'LoginForm') {
      next({ name: 'SearchPage' });
    } else {
      next();
    }
  }
});

export default router;
